export function canonicalSiteUrl(url: URL): URL {
  const canonical = new URL(url)
  canonical.pathname = canonical.pathname.replace(/^\/(en|ja)(?=\/|$)/, '') || '/'
  return canonical
}

export function localeFromPathname(pathname: string): 'ja' | 'en' | undefined {
  const prefix = pathname.match(/^\/(en|ja)(?=\/|$)/)?.[1]
  return prefix === 'ja' || prefix === 'en' ? prefix : undefined
}
